export const AppIcons = [
    {
        name: 'siu-universidad',
        path: '/assets/img/web/ico/ico-universidad-blanco.svg'
    },

    {
        name: 'siu-carrera',
        path: '/assets/img/web/ico/ico-carreras-blanco.svg'
    },

    {
        name: 'siu-enlaces1',
        path: '/assets/img/web/principal/enlaces/1.svg'
    },

    {
        name: 'siu-enlaces2',
        path: '/assets/img/web/principal/enlaces/2.svg'
    },

    {
        name: 'siu-enlaces3',
        path: '/assets/img/web/principal/enlaces/3.svg'
    },

    {
        name: 'siu-enlaces1-hover',
        path: '/assets/img/web/principal/enlaces/1-hover.svg'
    },

    {
        name: 'siu-enlaces2-hover',
        path: '/assets/img/web/principal/enlaces/2-hover.svg'
    },

    {
        name: 'siu-enlaces3-hover',
        path: '/assets/img/web/principal/enlaces/3-hover.svg'
    },

    {
        name: 'tuni-maletin-blanco',
        path: '/assets/img/web/ico/ico-maletin-blanco.svg'
    },
    //
    {
        name: 'tuni-icono-admision',
        path: '/assets/svg/icons/icono_admision.svg'
    },
    {
        name: 'tuni-icono-area',
        path: '/assets/svg/icons/icono_area.svg'
    },
    {
        name: 'tuni-icono-collapsed',
        path: '/assets/svg/icons/icono_collapsed.svg'
    },
    {
        name: 'tuni-icono-compartir',
        path: '/assets/svg/icons/icono_compartir.svg'
    },
    {
        name: 'tuni-icono-comunidad',
        path: '/assets/svg/icons/icono_comunidad.svg'
    },
    {
        name: 'tuni-icono-condicion-lab',
        path: '/assets/svg/icons/icono_condicion-lab.svg'
    },
    {
        name: 'tuni-icono-docentes',
        path: '/assets/svg/icons/icono_docentes.svg'
    },
    {
        name: 'tuni-icono-expand',
        path: '/assets/svg/icons/icono_expand.svg'
    },
    {
        name: 'tuni-icono-grado',
        path: '/assets/svg/icons/icono_grado.svg'
    },
    {
        name: 'tuni-icono-hombres',
        path: '/assets/svg/icons/icono_hombres.svg'
    },
    {
        name: 'tuni-icono-mail',
        path: '/assets/svg/icons/icono_mail.svg'
    },
    {
        name: 'tuni-icono-malla',
        path: '/assets/svg/icons/icono_malla.svg'
    },
    {
        name: 'tuni-icono-modalidad',
        path: '/assets/svg/icons/icono_modalidad.svg'
    },
    {
        name: 'tuni-icono-mujeres',
        path: '/assets/svg/icons/icono_mujeres.svg'
    },
    {
        name: 'tuni-icono-nivel-acad',
        path: '/assets/svg/icons/icono_nivel-acad.svg'
    },
    {
        name: 'tuni-icono-regimen',
        path: '/assets/svg/icons/icono_regimen.svg'
    },
    {
        name: 'tuni-icono-renacyt',
        path: '/assets/svg/icons/icono_renacyt.svg'
    },
    {
        name: 'tuni-icono-telefono',
        path: '/assets/svg/icons/icono_telefono.svg'
    },
    {
        name: 'tuni-icono-web',
        path: '/assets/svg/icons/icono_web.svg'
    },
];